import React from "react";
import banner from "../../asset/about rda banner.png";
import bannerSm from "../../asset/about rda banner sm.png";

const AboutRDA = () => {
  return (
    <div className="flex flex-col gap-10  md:pb-20 pb-10  xl:px-[5%] lg:px-[3%] md:px-[3%] px-[6%]  bg-white md:bg-[#F6F6F6]">
      <div className="xl:py-6 lg:py-4 py-3">
        <img
          src={banner}
          alt=""
          className="w-full lg:rounded-2xl rounded-xl md:flex hidden"
        />
        <img
          className="w-full rounded-lg flex md:hidden"
          src={bannerSm}
          alt=""
        />
      </div>
      <div className=" flex flex-col md:gap-10 gap-6 ">
        <div className=" flex flex-col md:gap-3 gap-2">
          <h1 className="font-semibold md:text-[2.5rem] text-[1.8rem]">
            History
          </h1>
          <p className="md:text-[1.3rem] text-[1rem] text-[#7A7A7A]">
            Rawalpindi Development Authority (RDA) was established in May 1989
            under the Act of the Development of cities by the Punjab Government
            as an autonomous governing body replacing Rawalpindi Improvement
            Trust (RIT) with Rawalpindi Development Authority (RDA). The
            Rawalpindi Development Authority started functioning on March 1992.
          </p>
        </div>
        <div className=" flex flex-col md:gap-3 gap-2">
          <h1 className="font-semibold md:text-[2.5rem] text-[1.8rem]">
            Vision
          </h1>
          <p className="md:text-[1.3rem] text-[1rem] text-[#7A7A7A]">
            Rawalpindi Development Authority seeks to be a public-friendly
            principal planning, development and improvements organization in
            Rawalpindi city, The aim of the Rawalpindi Development Authority
            (RDA) is facilitating and enabling provision and continuously
            improving metropolis-wide development works, facilities, services
            and incentives of acceptable and Modern World standards for
            Residential and Commercial outlets in Rawalpindi city.
          </p>
        </div>
        <div className=" flex flex-col md:gap-3 gap-2">
          <h1 className="font-semibold md:text-[2.5rem] text-[1.8rem]">
            Territory
          </h1>
          <p className="md:text-[1.3rem] text-[1rem] text-[#7A7A7A]">
            Rawalpindi Development Authority is spread over the Municipal
            Committee Rawalpindi and 64 other Revenue Estates of Rawalpindi,
            except Cantonment Board. The controlled area of Rawalpindi
            Development Authority is around 311 Sq. Km.
          </p>
        </div>
      </div>
    </div>
  );
};

export default AboutRDA;
